import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  signal,
  ViewChild,
} from '@angular/core';
import { DocumentService } from '@app/shared/services';
import { MatDialog } from '@angular/material/dialog';
import { Observable, Subscription } from 'rxjs';
import { AddDocumentComponent } from '../add-document.component';
import { AddTrustTemplate } from '@app/shared/component/add-trust-template-dialog/add-trust-template.interfaces';
import { AddEntityDilaogComponent } from '../../dialogs/add-entity-dilaog/add-entity-dilaog.component';
import { CreateFromWithVaultComponent } from '@app/shared/component/create-from-with-vault/create-from-with-vault.component';
import { environment } from '@env/environment';
import { fetchAuthSession } from '@aws-amplify/auth';
import { MatMenuTrigger } from '@angular/material/menu';
import { AnimationOptions } from 'ngx-lottie';
import { ToastrService } from 'ngx-toastr';
import { SharedVaultService } from '@app/shared/services/vault/shared-vault.service';
import { UntypedFormControl } from '@angular/forms';
import { ChecklistTaskService } from '@app/shared/services/checklist/checklist-task.service';
import { Store } from '@ngrx/store';
import { RootStoreState } from '@app/root-store';
import * as vaultStoreActions from '@app/root-store/vault-store/actions';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'document-linking-template',
  templateUrl: './document-linking-template.component.html',
  styleUrl: './document-linking-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentLinkingTemplateComponent implements OnInit, OnDestroy {
  @Input() currentFormId;
  @Input() currentuserId;
  @Input() origin;
  @Input() showButton = true;
  @Input() formName;
  @Input() data;
  @Input() hideManageButton;
  @Input() formsList;
  @Input() categories;
  @Input() isRemoveEditSaveSharing = false;
  @Output() vaultSelectionUpdateEvent = new EventEmitter<any>();
  @Output() aiRunningEvent = new EventEmitter<any>();
  @Output() aiFetchDocumentEvent = new EventEmitter<any>();
  @Output() linkedFormsUpdated = new EventEmitter<void>();
  @Output() documentLinkedTemplateSelectionChange = new EventEmitter<{
    template: any;
    index: number;
    isChecked: boolean;
    type: 'linked_template' | 'existing_ai_suggestion' | 'new_ai_suggestion';
  }>();
  @ViewChild('globalSearchIcon') globalSearchIcon: ElementRef;
  suggestions_data = [];
  suggestions_data_already_in_system = [];
  isInputFocused = false;
  searchText = '';
  searchTextNew = '';
  existingTemplates = [];
  newTemplateSuggestions = [];
  existingTemplateSuggestions = [];
  isExistingTemplatesLoading = true;
  textBoxPlaceHolder = 'Search Existing Templates';
  textBoxPlaceHolderCreate = 'New Template Options';
  connectionUserFormControl = new UntypedFormControl();
  connectionNewUserFormControl = new UntypedFormControl();
  subscription = new Subscription();
  linkedForms = [];
  isLoading = true;
  ai_is_loading = false;
  animation: AnimationOptions = {
    path: '/assets/lottie/animation-4.json',
  };
  filterType = 'All Types';
  filterTypeNew = 'All Types';
  filterTypeList = [];
  selectionState: { [key: string]: boolean } = {};
  isIpadOrTabletScreenWidth = signal(false);
  screenWidth: number;

  // Worker reference for proper cleanup
  private checkStatusWorker: Worker | undefined;

  constructor(
    private documentService: DocumentService,
    private dialog: MatDialog,
    private checklistTaskService: ChecklistTaskService,
    private cd: ChangeDetectorRef,
    private store$: Store<RootStoreState.State>,
    private sharedVaultService: SharedVaultService,
    private toastr: ToastrService
  ) {}
  ngOnInit(): void {

    if (this.isRemoveEditSaveSharing) {
      this.connectionUserFormControl.disable();
      this.connectionNewUserFormControl.disable();
    }
    
    this.checkStatus();
  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();

    // Terminate worker
    if (this.checkStatusWorker) {
      this.checkStatusWorker.terminate();
      this.checkStatusWorker = undefined;
    }
  }
  aiLoading() {
    this.ai_is_loading = true;
    this.cd.detectChanges();
    this.checkStatus();
  }
  onInputFocusNew() {
    this.isInputFocused = true;
    this.globalSearchIcon.nativeElement.style.display = 'none';
    this.cd.detectChanges();
  }

  onInputBlurNew() {
    this.isInputFocused = false;
    this.globalSearchIcon.nativeElement.style.display = 'inline-block';
    this.cd.detectChanges();
  }
  onInputFocus() {
    this.isInputFocused = true;
    // this.initData();
    // if (!this.connectionUserFormControl.value) {
    //   this.isListViewOpen = false;
    // }
    this.globalSearchIcon.nativeElement.style.display = 'none';
    this.cd.detectChanges();
  }

  onInputBlur() {
    this.isInputFocused = false;
    this.globalSearchIcon.nativeElement.style.display = 'inline-block';
    this.cd.detectChanges();
  }

  clearInput() {
    this.connectionUserFormControl.setValue('');
  }
  clearInputNew() {
    this.connectionNewUserFormControl.setValue('');
  }

  async checkStatus(isLoading = true) {
    this.isLoading = isLoading;
    if (this.isLoading) {
      this.linkedForms = [];
      this.suggestions_data = [];
    }
    this.cd.detectChanges();

    // Terminate previous worker if exists
    if (this.checkStatusWorker) {
      this.checkStatusWorker.terminate();
    }

    return await new Promise(async (resolve) => {
      if (typeof Worker !== 'undefined') {
        this.checkStatusWorker = new Worker(new URL('./document-linking-template.worker', import.meta.url), { type: 'module' });

        const data = {
          token: '',
          url: `${environment.apiUrl}/api/vault/check-upload-file-ai-running`,
          vault_user_form_id: this.currentFormId,
          execution_type: 'template_summary_2',
        };
        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();

        const token = `Bearer ${idToken}`;
        data.token = token;
        this.checkStatusWorker.onmessage = async ({ data }) => {
          if (data.data.ai_is_running) {
            this.ai_is_loading = true;
            setTimeout(() => {
              this.checkStatus();
            }, 15000);
          } else {
            this.ai_is_loading = false;
            this.getSuggestions();
            this.getLinkedForms();
          }
          resolve(data);
        };
        this.checkStatusWorker.postMessage(data);
      } else {
        this.isLoading = false;
        resolve(null);
      }
    });
  }
  deleteFileFunction(template) {
    this.subscription.add(
      this.deleteFileFunctionObservable(template).subscribe((result) => {
        this.getLinkedForms();
      })
    );
  }
  linkTemplateExistingForm(item) {
    item.suggested_vault_user_form_id = item.id;
    this.assccitareform(item);
  }
  createFileNew(item) {
    item.suggested_vault_form_id = item.id;
    this.createFile(item);
  }
  linkTemplate(template) {
    const id = template.ai_suggestion_id ? template.ai_suggestion_id : template.id;
    this.subscription.add(
      this.documentService.updateDeactvateSuggestion(id).subscribe((res) => {
        if (template.suggested_vault_user_form_id) {
          this.assccitareform(template);
        } else {
          this.createFile(template);
        }
      })
    );
  }
  createFile(file) {
    if (file?.organization_section?.includes('Entities')) {
      const dialogRef = this.dialog.open(AddEntityDilaogComponent, {
        panelClass: 'full-window-dialog',
        autoFocus: false,
        data: { entityType: file.suggested_vault_form_id, entityName: file.new_form_name },
      });
      this.subscription.add(
        dialogRef.afterClosed().subscribe((res) => {
          if (res?.status === 'success') {
            file.suggested_vault_user_form_id = res.id ? res.id : res.data.id;
            this.store$.dispatch(new vaultStoreActions.GetVaultRequestAction(this.currentuserId, false));
            this.vaultSelectionUpdateEvent.emit({
              action: 'update_vault_selection',
            });
            this.toastr.success(`${file.type} has been created successfully`);
            this.assccitareform(file);
          }
        })
      );
    } else {
      const dialogRef = this.dialog.open<CreateFromWithVaultComponent, AddTrustTemplate>(CreateFromWithVaultComponent, {
        data: {
          inbox_attachment_id: undefined,
          vault_id: undefined,
          vaultFormId: file.suggested_vault_form_id,
          title: this.formsList.find((x) => x.id == file.suggested_vault_form_id)?.type,
          vaultType: undefined,
          organization_section: file.organization_section,
          hub_vault_user_form_id: undefined,
          origin: undefined,
        },
      });
      this.subscription.add(
        dialogRef.afterClosed().subscribe(
          (res) => {
            if (res?.status) {
              this.toastr.success(`${file.type} has been created successfully`);
              file.suggested_vault_user_form_id = res.id ? res.id : res.data.id;
              this.assccitareform(file);
            }
          },
          (error) => {}
        )
      );
    }
  }
  refetchDocument() {
    this.subscription.add(
      this.sharedVaultService
        .refreshDocument({
          vault_user_form_id: this.currentFormId,
          user_id: this.currentuserId,
          execution_type: 'template_summary_2',
        })
        .subscribe((res) => {
          this.checkStatus();
        })
    );
  }
  assccitareform(template) {
    let payload = {
      user_id: this.currentuserId,
      vault_user_form_id: [template.suggested_vault_user_form_id],
      created_by_user_id: this.currentuserId,
      association_type: 'Documents',
      associate_vault_user_form_id: this.currentFormId,
    };
    this.subscription.add(
      this.documentService.createUserFormAssociationMultiple(payload).subscribe(
        (res) => {
          this.checkStatus(false);
        },
        (error) => {}
      )
    );
  }
  removeDocumentLinkedTemplateSuggestion(template) {
    this.subscription.add(
      this.updateDeactvateSuggestionObservable(template).subscribe((res) => {
        this.getSuggestions(false);
      })
    );
  }

  getSuggestions(isLoading = true) {
    this.isLoading = isLoading;
    this.subscription.add(
      this.documentService.getFormLinkingSuggestions(this.currentFormId).subscribe((res) => {
        if (res && res?.length > 0) {
          this.newTemplateSuggestions = res
            .filter((x) => x.suggested_vault_form_id)
            .map((x) => ({
              ...x,
              ai_suggestion: true,
            }));
          this.existingTemplateSuggestions = res
            .filter((x) => x.suggested_vault_user_form_id)
            .map((x) => ({
              ...x,
              ai_suggestion: true,
            }));
          this.suggestions_data = res.filter((x) => x.suggested_vault_form_id);

          this.suggestions_data_already_in_system = [
            ...new Map(res.filter((x) => x.suggested_vault_user_form_id).map((x) => [x.suggested_vault_user_form_id, x])).values(),
          ];
        } else {
          this.suggestions_data_already_in_system = [];
          this.suggestions_data = [];
        }
        this.mergeTemplates();
        this.isLoading = false;
        this.cd.detectChanges();
      })
    );

    this.formsList = this.formsList.map((x) => ({
      ...x,
      ai_suggestion: false,
      ai_suggestion_id: null,
    }));
    this.filterTypeList = ['All Types', ...new Set(this.categories.map((x) => x.name))];
    this.filterTypeList = this.filterTypeList.filter((x) => x !== 'Documents');
    this.getFormExistingTemplates();
  }
  getFormExistingTemplates() {
    this.subscription.add(
      this.checklistTaskService.getAllForms(this.currentuserId).subscribe((res) => {
        this.existingTemplates = res.data.map((x) => ({
          ...x,
          ai_suggestion: false,
          ai_suggestion_id: null,
        }));
        this.existingTemplates = this.existingTemplates.filter((x) => x.form_name);
        this.isExistingTemplatesLoading = false;
        this.mergeTemplates();
        this.cd.detectChanges();
      })
    );
  }
  mergeTemplates() {
    this.existingTemplates.forEach((x) => {
      if (this.existingTemplateSuggestions.findIndex((z) => z.suggested_vault_user_form_id == x.id) >= 0) {
        x.ai_suggestion = true;
        x.ai_suggestion_id = this.existingTemplateSuggestions.find((z) => z.suggested_vault_user_form_id == x.id).id;
      }
    });
    this.existingTemplates = this.existingTemplates.sort((a, b) => {
      if (a.ai_suggestion) {
        return -1;
      }
      return 1;
    });
    this.formsList.forEach((x) => {
      if (this.newTemplateSuggestions.findIndex((z) => z.suggested_vault_form_id == x.id) >= 0) {
        x.ai_suggestion = true;
        x.ai_suggestion_id = this.newTemplateSuggestions.find((z) => z.suggested_vault_form_id == x.id).id;
      }
    });
    this.formsList = this.formsList.sort((a, b) => {
      if (a.ai_suggestion) {
        return -1;
      }
      return 1;
    });
    this.cd.detectChanges();
  }
  openSuggestionTemplate(file) {
    let data = file;
    data.id = file.suggested_vault_user_form_id;
    const dialogOpen = this.dialog.open(AddDocumentComponent, {
      disableClose: true,
      data: {
        file: data,
        mode: 'edit',
        isintelligent: false,
        isfileListLoad: true,
        isFromChecklist: true,
        vufid: file.suggested_vault_user_form_id,
        vault_user_form_user_id: this.currentuserId,
        isReport: true,
      },
      panelClass: 'full-window-dialog-add-document',
      autoFocus: false,
    });
    this.subscription.add(
      dialogOpen.afterClosed().subscribe((res) => {
        this.checkStatus(false);
      })
    );
  }
  openManageTemplate(file) {
    const dialogOpen = this.dialog.open(AddDocumentComponent, {
      disableClose: true,
      data: {
        file,
        mode: 'edit',
        isintelligent: false,
        isfileListLoad: true,
        isFromChecklist: true,
        vufid: file.vault_user_form_id,
        vault_user_form_user_id: file.userid,
        isReport: true,
      },
      panelClass: 'full-window-dialog-add-document',
      autoFocus: false,
    });
    this.subscription.add(
      dialogOpen.afterClosed().subscribe((res) => {
        this.checkStatus(false);
      })
    );
  }
  getLinkedForms() {
    const body = {
      user_id: this.currentuserId,
      vault_user_form_id: this.currentFormId,
      type: 'documents',
    };
    this.subscription.add(
      this.documentService.getFormsLinkedDocuments(body).subscribe((res) => {
        if (res.length) {
          res = res.map((x) => {
            return {
              ...x,
              type_template: x.type_template.replace(/,\s*/g, ', '),
            };
          });
          this.linkedForms = res;
        } else {
          this.linkedForms = [];
        }

        this.isLoading = false;
        this.cd.detectChanges();
        // this.linkedFormsUpdated.emit();
      })
    );
  }

  deleteFileFunctionObservable(template: any): Observable<any> {
    return this.documentService.deleteUserMultipleFormAssociation(this.currentuserId, [template.id], this.currentFormId);
  }

  updateDeactvateSuggestionObservable(template: any): Observable<any> {
    return this.documentService.updateDeactvateSuggestion(template.id);
  }

  onDocumentLinkedTemplateSelectionChange(
    type: 'linked_template' | 'existing_ai_suggestion' | 'new_ai_suggestion',
    template: any,
    index: number,
    isChecked: boolean
  ) {
    const key =
      type === 'linked_template' ? `linked_template_${index}` : `suggestion_${type === 'existing_ai_suggestion' ? 'existing' : 'new'}_${index}`;
    this.selectionState[key] = isChecked;
    this.documentLinkedTemplateSelectionChange.emit({ type, template, index, isChecked });
    this.cd.detectChanges();
  }

  clearSelections() {
    this.selectionState = {};
    this.cd.detectChanges();
  }
}
